module.exports = __webpack_public_path__ + "static/media/card-email-mobile-es.10fd7d86.png";